// ** React Imports
import { useState } from "react";
import { useHistory } from "react-router-dom";

// ** Redux & Store & Actions
import { useDispatch, useSelector } from "react-redux";
import { registerVerifySmsCode } from "store/modules/auth";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import { toast } from "helpers/toastWrapper";

// ** Custom Hooks
import { useFingerprint } from "hooks/useFingerprint";
import { useGetUserAfterLogin } from "hooks/useGetUserAfterLogin";

// ** Helpers
import { trackUserRegistrationEmailVerificationSuccess } from "helpers/analytics";

// ** Routes
import routes from "containers";

// #####################################################

export const useVerifySmsCode = () => {
	const { t } = useTranslation(["common", "landing"]);
	const history = useHistory();
	const dispatch = useDispatch();

	const { getFingerprint } = useFingerprint();
	const { getUserAfterLogin } = useGetUserAfterLogin();

	const { login, id, hash } = useSelector(
		(state) => state.globalCommon.registrationVerifyPhoneModal
	);

	const [isVerifying, setIsVerifying] = useState(false);

	const verifySmsCode = ({ code }) => {
		getFingerprint()
			.then((resFingerprint) => {
				if (
					login !== undefined &&
					id !== undefined &&
					hash !== undefined &&
					resFingerprint
				) {
					setIsVerifying(true);
					dispatch(
						registerVerifySmsCode({
							login,
							id,
							hash,
							code,
							fingerprint: resFingerprint,
						})
					)
						.then((res) => {
							if (res && res.result?.status === 200) {
								trackUserRegistrationEmailVerificationSuccess();

								return getUserAfterLogin();
							}
						})
						.then((res) => {
							if (
								res &&
								res.meta?.requestStatus === "fulfilled"
							) {
								toast.success(
									t("landing:register.verificationSuccess")
								);

								history.push(`${routes.userpanel.path}/data`);
							}
						})
						.catch((res) => {
							toast.error(res?.response?.data?.error);
						})
						.finally(() => {
							setIsVerifying(false);
						});
				}
			})
			.catch(() => {
				// intentionally empty catch block
			});
	};

	return {
		verifySmsCode,
		isVerifying,
	};
};
